import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../../services/api";
import { HeyatYoluContext } from "../../App";
import { Helmet } from "react-helmet";
import "./styles/Login.css";

function Login() {
  const navigate = useNavigate();
  const { setUser } = useContext(HeyatYoluContext);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post("/account/login", form, {
        withCredentials: true,
      });

      setUser(res.data.user);
      navigate("/");
    } catch (err) {
      const serverError = err.response?.data;
      if (typeof serverError === "string") {
        setError(serverError);
      } else {
        setError("Email və ya şifrə yanlışdır.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lg-page">
      <Helmet>
        <title>Daxil ol – HeyatYolu</title>
        <meta name="description" content="HeyatYolu platformasına daxil olun. Profil yaradın, xatirələri paylaşın və yaddaşları yaşadın." />
        <meta name="keywords" content="daxil ol, giriş, heyatyolu, xatirə, profil, qeydiyyat, mərhum" />
        <meta property="og:title" content="Daxil ol – HeyatYolu" />
        <meta property="og:description" content="Xatirə paylaşmaq və profilə daxil olmaq üçün HeyatYolu hesabınıza giriş edin." />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="lg-container">
        <div className="lg-card">
          {/* Header Section */}
          <div className="lg-header">
            <div className="lg-icon">
              <i className="fas fa-dove"></i>
            </div>
            <h1 className="lg-title">Xoş Gəlmisiniz</h1>
            <p className="lg-subtitle">Xatirələr dünyasına daxil olun</p>
          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} className="lg-form">
            {/* Email Input */}
            <div className="lg-form-group">
              <label htmlFor="email" className="lg-form-label">
                <i className="fas fa-envelope"></i>
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="email@example.com"
                required
                value={form.email}
                onChange={handleChange}
                className="lg-form-input"
                autoComplete="email"
              />
            </div>

            {/* Password Input */}
            <div className="lg-form-group">
              <label htmlFor="password" className="lg-form-label">
                <i className="fas fa-lock"></i>
                Şifrə
              </label>
              <div className="lg-password-wrapper">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="••••••••"
                  required
                  value={form.password}
                  onChange={handleChange}
                  className="lg-form-input"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="lg-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password visibility"
                >
                  <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div className="lg-error-message">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}

            {/* Forgot Password Link */}
            <div className="lg-forgot-password">
              <Link to="/sifreni-unutdum" className="lg-forgot-link">
                Şifrəni unutmusunuz?
              </Link>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="lg-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="lg-spinner"></span>
                  Daxil olunur...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  Daxil ol
                </>
              )}
            </button>
          </form>

          {/* Divider */}
          <div className="lg-divider">
            <span>və ya</span>
          </div>

          {/* Sign Up Link */}
          <div className="lg-signup-section">
            <p className="lg-signup-text">
              Hesabınız yoxdur?
            </p>
            <Link to="/qeydiyyat" className="lg-signup-link">
              <i className="fas fa-user-plus"></i>
              Qeydiyyat et
            </Link>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="lg-decoration">
          <div className="lg-decoration-circle lg-circle-1"></div>
          <div className="lg-decoration-circle lg-circle-2"></div>
          <div className="lg-decoration-circle lg-circle-3"></div>
        </div>
      </div>
    </div>
  );
}

export default Login;